let Messages = [
  'All their equipment and instruments are alive.',
  'A red flair silhouetted the jagged edge of a wing.',
  'I watched the storm, so beautiful yet terrific.',
  'Almost before we knew it, we had left the ground.',
  'A shining crescent far beneath the flying vessel.',
  'It was going to be a lonely trip back.',
  'Mist enveloped the ship three hours out from port.',
  'My two natures had memory in common.',
  'Silver mist suffused the deck of the ship.',
  'The face of the moon was in shadow.',
  'She stared through the window at the stars.',
  'The recorded voice scratched in the speaker.',
  'The sky was cloudless and of a deep dark blue.',
  'The spectacle before us was indeed sublime.',
  'Then came the night of the first falling star.',
  'Waves flung themselves at the blue evening.'
];

export default Messages;
